module.exports = __webpack_public_path__ + "static/media/13.a163d59d.png";